import intersectionBy from 'lodash/intersectionBy';
import invariant from 'invariant';
export * from './authzList';
export class Authz {
    constructor() {
        this.roleList = [];
        this.initializedRoleList = false;
        this.initializedAuthData = false;
        this._authData = {};
    }
    initRoleList(roleList) {
        this.roleList = roleList;
        this.initializedRoleList = true;
    }
    getAuthData() {
        if (!this.initializedAuthData) {
            return {};
            // invariant(false, 'must init authData before you use it');
        }
        return this._authData;
    }
    setAuthData($authData) {
        this.initializedAuthData = true;
        this._authData = $authData;
        const resources = JSON.parse($authData.resources).reduce((pre, next) => {
            return [...pre, next.code];
        }, []);
        this.initRoleList(resources);
    }
    hasPermission(target, isCongruent = false) {
        if (!this.initializedRoleList) {
            invariant(false, 'must init authzRoleList before you use it');
        }
        const resultLen = intersectionBy(target, this.roleList).length;
        return isCongruent ? target.length === resultLen : resultLen > 0;
    }
    superAuthJudge(...args) {
        for (let i = 0; i < args.length; i++) {
            if (this.hasPermission(args[i], true)) {
                return true;
            }
        }
    }
}
const authz = new Authz();
export default authz;
